
import Loading from './components/common/loading/Loading.vue'
import Confirm from 'vux/src/components/confirm/index.vue'

export default {
name: 'app',
data(){
return {
direction: "forward",
routes: ["/giveawayStation", "/pickupStation", "/giveawayStation", "/giveawayAircraft"],
shouldShow: this.$until.getUrlParam("from")&&this.$until.getUrlParam("from")!=='null'&&location.href.indexOf("pickupStation")!=-1?(!this.$until.getUrlParam("version")||this.$until.getUrlParam("version")=="0"? false : true):true,
ConfirmShow:  this.$until.getUrlParam("from")&&this.$until.getUrlParam("from")!=='null'&&location.href.indexOf("pickupStation")!=-1?(!this.$until.getUrlParam("version")||this.$until.getUrlParam("version")=="0"?true : false):false
}
},
components: {
Loading,
Confirm
},
watch: {
'$store.state.mutations.toastshow': function (v,c) {
if(v){
let that = this
this.$vux.toast.show({
text: this.$store.state.mutations.toastMsg,
type: "text",
onHide(){
that.$store.dispatch('hideToast')
}
})
}
}
},
beforeCreate(){
if(!this.$until.getUrlParam("version") && this.$until.getUrlParam("from")){
return;
}

if(localStorage.getItem('useCar_jb_channelCode')){
if(this.$until.getUrlParam('channelCode')){
if(localStorage.getItem('useCar_jb_channelCode') != this.$until.getUrlParam('channelCode')){
localStorage.setItem('useCar_jb_channelCode',this.$until.getUrlParam('channelCode'));
}
}
}else {
if(this.$until.getUrlParam('channelCode')){
localStorage.setItem('useCar_jb_channelCode',this.$until.getUrlParam('channelCode'));
}
}


if(this.$until.getUrlParam('personNum')){
sessionStorage.setItem('jbpersonNum',this.$until.getUrlParam('personNum'))
}


this.$http.post(window.innerAPI + "?server=queryPreDay", {
}).then(res => {
if(res.data.data.code){return;}

localStorage.setItem("$PreDate", res.data.data.data)
})


if(localStorage.getItem("personLabel")&&(localStorage.getItem("cdqcp_opid") || localStorage.getItem("useCar_cdqcp_opid"))){
localStorage.removeItem("personLabel");
return;
}
var appFrom =  this.$until.getUrlParam("from");
let opendId = this.$until.getUrlParam('openId');
if((!opendId||opendId==='null')&&appFrom){
localStorage.setItem("appFrom",appFrom);
localStorage.removeItem("$currentCity")
localStorage.removeItem("cdqcp_conn");
localStorage.removeItem("cdqcp_opid");
localStorage.removeItem("useCar_cdqcp_opid");
localStorage.removeItem("jbStorage");
localStorage.removeItem("userMessage");
return;
}
var appFrom1 =  window.localStorage.getItem("appFrom");
if(!this.$until.getUrlParam('openId') && !appFrom1){
localStorage.removeItem("jbStorage");
}
if(!localStorage.getItem("cdqcp_opid") || !localStorage.getItem("useCar_cdqcp_opid")){
localStorage.removeItem("userMessage");
localStorage.removeItem("cdqcp_conn");
localStorage.removeItem("useCar_cdqcp_conns");
}
},
methods: {
comeBack(){
location.href = "##backToVC=1";
},
comeGo(){
window.location = "http://c3.cli.im/DxB9P2"
}

},

mounted(){

this.shouldShow =  this.$until.getUrlParam("from")&&this.$until.getUrlParam("from")!=='null'&&location.href.indexOf("pickupStation")!=-1?(!this.$until.getUrlParam("version")||this.$until.getUrlParam("version")=="0" ? false : true):true,
this.ConfirmShow =   this.$until.getUrlParam("from")&&this.$until.getUrlParam("from")!=='null'&&location.href.indexOf("pickupStation")!=-1?(!this.$until.getUrlParam("version") ||this.$until.getUrlParam("version")=="0" ? true : false):false
},
}



// WEBPACK FOOTER //
// ./src/App.vue